import {
  REQUEST_HOLIDAY_CREATE, REQUEST_HOLIDAY_CREATE_FAILURE, REQUEST_HOLIDAY_CREATE_SUCCESS,
  GET_REQUEST_HOLIDAY, GET_REQUEST_HOLIDAY_FAILURE, GET_REQUEST_HOLIDAY_SUCCESS
} from './mutation-types'

export default {
  state: {
  },
  getters: {
  },
  actions: {
    [REQUEST_HOLIDAY_CREATE] ({dispatch, state, commit}, params) {
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiPost', {url: '/asovi/request_holidays', data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(REQUEST_HOLIDAY_CREATE_FAILURE, res.data)
          } else {
            commit(REQUEST_HOLIDAY_CREATE_SUCCESS, { data: res.data, callback: params.callback })
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [GET_REQUEST_HOLIDAY] ({dispatch, state, commit}, params = null) {
      var data = {}
      data = params.data
      dispatch('apiGet', {url: '/asovi/request_holidays', data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(GET_REQUEST_HOLIDAY_FAILURE, res.data)
          } else {
            commit(GET_REQUEST_HOLIDAY_SUCCESS, {data: res.data, callback: params.callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    }
  },
  mutations: {
    [REQUEST_HOLIDAY_CREATE_FAILURE] (state, data) {
      console.log('REQUEST_HOLIDAY_CREATE_FAILURE')
    },
    [REQUEST_HOLIDAY_CREATE_SUCCESS] (state, data) {
      console.log('REQUEST_HOLIDAY_CREATE_SUCCESS')
      if (data.callback) {
        data.callback()
      }
    },
    [GET_REQUEST_HOLIDAY_FAILURE] (state, data) {
      console.log('GET_REQUEST_HOLIDAY_FAILURE')
    },
    [GET_REQUEST_HOLIDAY_SUCCESS] (state, data) {
      console.log('GET_REQUEST_HOLIDAY_SUCCESS')
      if (data.callback) {
        data.callback(data.data.data)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/request-holiday.js